import { createBrowserRouter } from 'react-router';
import { ClientLayout } from '@/features/studio/ClientLayout';
import { StudioRoot } from '@/features/studio/StudioRoot';
import { HomePage } from '@/features/home/HomePage';
import { ServicesPage } from '@/features/services/ServicesPage';
import { MyBookingsPage } from '@/features/my/MyBookingsPage';
import { BookingDetailsPage } from '@/features/my/BookingDetailsPage';
import { NotFoundPage, RootPage, RouteErrorPage } from './RootPages';

export const router = createBrowserRouter([
  { path: '/', element: <RootPage />, errorElement: <RouteErrorPage /> },
  {
    path: '/s/:slug',
    element: <StudioRoot />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        element: <ClientLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'services', element: <ServicesPage /> },
          { path: 'my', element: <MyBookingsPage /> },
          // Booking id travels in ?id= (see shared/routes.ts); the path form stays for old links.
          { path: 'booking', element: <BookingDetailsPage /> },
          { path: 'my/:bookingId', element: <BookingDetailsPage /> },
          { path: 'assistant', lazy: async () => ({ Component: (await import('@/features/assistant/ClientAssistantPage')).ClientAssistantPage }) },
        ],
      },
      { path: 'owner/*', lazy: async () => ({ Component: (await import('@/features/owner/OwnerApp')).OwnerApp }) },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
